module.exports = __webpack_public_path__ + "img/Como-logo-icon.b1ebd38b.png";